import { signOut } from "firebase/auth";
import { callApi } from "@gull/shared";
import { auth, ENDUSER_API, getAppCheckHeader } from "./firebase";

export class ApiError extends Error {
  code: string;
  status: number;
  constructor(status: number, code: string, message: string) {
    super(message);
    this.code = code;
    this.status = status;
  }
}

async function call<T>(path: string, init: RequestInit = {}, requireAuth = false): Promise<T> {
  const user = auth.currentUser;
  if (requireAuth && !user) throw new ApiError(401, "UNAUTHENTICATED", "Ikke innlogget");
  const result = await callApi<T>(async (forceRefreshToken) => {
    const headers: Record<string, string> = {
      ...(init.headers as Record<string, string> | undefined),
      ...(await getAppCheckHeader()),
      "Content-Type": "application/json",
    };
    if (requireAuth && user) {
      headers.Authorization = `Bearer ${await user.getIdToken(forceRefreshToken)}`;
    }
    return fetch(`${ENDUSER_API}${path}`, { ...init, headers });
  }, requireAuth);
  if (result.ok) return result.data;
  // Signing out lets the customer log in again.
  if (result.sessionEnded) await signOut(auth);
  throw new ApiError(result.status, result.code, result.message);
}

export const enduserApi = {
  publicGet: <T>(path: string) => call<T>(path, { method: "GET" }, false),
  publicPost: <T>(path: string, body: unknown) =>
    call<T>(path, { method: "POST", body: JSON.stringify(body) }, false),
  publicPatch: <T>(path: string, body: unknown) =>
    call<T>(path, { method: "PATCH", body: JSON.stringify(body) }, false),
  authedGet: <T>(path: string) => call<T>(path, { method: "GET" }, true),
  authedPost: <T>(path: string, body: unknown) =>
    call<T>(path, { method: "POST", body: JSON.stringify(body) }, true),
  authedPatch: <T>(path: string, body: unknown) =>
    call<T>(path, { method: "PATCH", body: JSON.stringify(body) }, true),
};
